import React, {Component} from "react";
// import header1 from "../image/header1.jpg";
import header1_compress from "../image/header1_compress.jpg";
import logo from "../image/atman fish banner.png";
import bigLogo from "../image/atman_logo.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faFileAlt} from "@fortawesome/free-solid-svg-icons";
import {Link} from "react-router-dom";
import MenuItems from "./menuItems";
import ScrollToTop from "../routering/ScrollToTop";
import HeaderBar from "./headerBar";

export default class PageHeader extends Component {
    state = {
        headerPhoto: header1_compress,
    };

    render(){
        let toTop = function(){
            document.documentElement.scroll(0, 0);
        };

        return <header>
            {/*<nav className="navbar navbar-expand-lg fixed-top navbar-transparent " color-on-scroll="300" >*/}
            {/*    <div className="container">*/}
            {/*        <div className="navbar-translate">*/}
            {/*            <Link to="/" className="navbar-brand" href="#" rel="tooltip" data-placement="bottom" onClick={toTop}>*/}
            {/*                    <img src={logo} className="imageLogo-xs-vh"/>*/}
            {/*                    <span style={{*/}
            {/*                        "fontSize": "2vh",*/}
            {/*                        "verticalAlign": "text-top",*/}
            {/*                        "color": "#abc335",*/}
            {/*                    }}>Chuang Xing</span>*/}
            {/*                    /!*<img src={bigLogo} className="imageLogo-m"/>*!/*/}
            {/*            </Link>*/}
            {/*            <button className="navbar-toggler navbar-toggler" type="button" data-toggle="collapse"*/}
            {/*                    data-target="#navigation" aria-controls="navigation-index" aria-expanded="false"*/}
            {/*                    aria-label="Toggle navigation">*/}
            {/*                <span className="navbar-toggler-bar bar1"></span>*/}
            {/*                <span className="navbar-toggler-bar bar2"></span>*/}
            {/*                <span className="navbar-toggler-bar bar3"></span>*/}
            {/*            </button>*/}
            {/*        </div>*/}
            {/*        <div className="collapse navbar-collapse justify-content-end" id="navigation">*/}
            {/*            <MenuItems/>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</nav>*/}

            <HeaderBar />

            <div className="page-header" data-parallax="true"
                 style={{
                     "backgroundImage": `url(${this.state.headerPhoto})`,
                 }}>
                <div className="filter"></div>
                <div className="container">
                    <div className="motto text-center">
                        {/*<h1>Chuang Xing</h1>*/}
                        <img src={bigLogo} className="imageLogo-l" style={{
                            "filter": "brightness(1.5)",
                        }}/>
                        <h3>High-Quality Aquarium Equipment Manufacturer</h3>
                        <Link to="/catalogue">
                            <button type="button" className="btn btn-success mt-3 downloadCatalogBtn">Download Catalogue</button>
                        </Link>
                        <br/>
                    </div>
                </div>
                <div className="icon-scroll"></div>
            </div>
        </header>
    }
}